// extracted by mini-css-extract-plugin
module.exports = {"content":"GridContent_content__AGRMb"};